import {Container, BoxInfo, BeerImage, LeftSide, RightSide, Options} from "./style"

import {IBeerProps} from "../../interfaces/index"
import {TPartyTypeProps} from "../../types/index"


interface ICardBeerProps {
    beer: IBeerProps
    addBeer: (beer: IBeerProps, type: TPartyTypeProps) => void
}


const CardBeer = ({beer, addBeer}: ICardBeerProps) => {
    return (
        <Container>
            <BoxInfo>
                <LeftSide>
                    <BeerImage>
                        <img src={beer.image_url} alt={beer.name} />    
                    </BeerImage> 
                </LeftSide>
                <RightSide>
                    <div className="beerName">
                        <p>{beer.name}</p>
                    </div>
                    <div className="beerDescription">
                        <p>{beer.description}</p>
                    </div>
                </RightSide>
            </BoxInfo>
            <Options>
                <button type="button" onClick={() => addBeer(beer, "Graduation")}>Formatura</button>
                <button type="button" onClick={() => addBeer(beer, "Wedding")}>Casamento</button>
                <button type="button" onClick={() => addBeer(beer, "Confraternization")}>Confraternização</button>
            </Options>
        </Container>
    )
}

export default CardBeer